import moment from 'moment';
import 'moment/locale/nl';

let module = angular.module('app.filters', [])
.filter('addVal', function() {
	return function(val1, val2) {
		if (!val1) return "";
		var sub = val1.substring(1);
		var i = parseFloat(sub.split('.').join(''));
		var j = parseFloat(val2);
		if(i+j < 0) return "0";
		return i + j;
	};
})
.filter('toCurrency', function(
		Language
	) {
	var lan = Language.get();
	return function(val, pre) {

		if (!val) {
			val = 0;
		}

		var res = val.toLocaleString(lan, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		if (pre) {
			res = pre+res;
		}
		return res;
	};
})
.filter('toLocalNumber', function(
		Language
	) {
	var lan = Language.get();
	return function(val, d) {
		if (!val) {
			val = 0;
		}
		var res = val.toLocaleString(lan, {
			minimumFractionDigits: d,
			maximumFractionDigits: d
		});
		return res;
	};
})
.filter('fromNow', ($rootScope) => {
	"ngInject"
	return (date) => {
		var today = moment().startOf('day');
		var subject = moment(date);
		if (subject >= today) {
			return moment(date).fromNow();
		} else {
			return today.format('LL');
		}
	}
})
.filter('toNumber', function() {
	return function(val1) {
		var matches = val1.match(/(\+|-)?((\d+(\.\d+)?)|(\.\d+))/);
		return matches && matches[0] || null;
	};
})

.filter('abs', function() {
	return function(val) {
		return Math.abs(val);
	};
})

.filter('cut', function() {
	return function(value, wordwise, max, tail) {
		if (!value) return '';
		max = parseInt(max, 10);
		if (!max) return value;
		if (value.length <= max) return value;
		value = value.substr(0, max);
		if (wordwise) {
			var lastspace = value.lastIndexOf(' ');
			if (lastspace != -1) {
				value = value.substr(0, lastspace);
			}
		}
		return value + (tail || '...');
	};
})

.filter('toString', function() {
	return function(data) {
		if (!data) return '';
		if(typeof data === 'object') {
			return data.join(', ');
		} else {
			return data;
		}
	};
})

.filter('unsafe', function($sce) {
	"ngInject";

	return function(val) {
		return $sce.trustAsHtml(val);
	};
})

.filter('translate', function(
	Language, 
	Session, 
	$rootScope
) {

	"ngInject";
	function translate(string, lan) {

		var translations = Session.get('translations');

		if (translations !== null && translations.hasOwnProperty(string)) {
			if (lan) {
				return translations[string][lan];
			} else {
				return translations[string][$rootScope.language];
			}
		}
		
		console.log('Translation '+string+' not available');
		return string;
	};

	//translate.$stateful = true; //makes sure that when rootScope changed reruns

	return translate;
})

.filter('nl2br', function() {
	return function(string) {
		var breakTag = '<br>';
		return (string + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	};
})

.filter('byHour',function(){
	return function(string){
		return string;
	}
})

.filter('ucfirst', function() {
	return function (string) {
		if (string) {
			var cap = string.substring(0, 1).toUpperCase();
			return cap + string.substring(1);
		}
		
	}
})

.filter('time', function() {
	return function(key) {
		var d = new Date(key.replace(/-/g, '/'));
		var day = d.getDate().toString();
		var month = (d.getMonth()+1).toString();
		var year = d.getFullYear().toString();
		var hour = d.getHours().toString();
		var minute = d.getMinutes().toString();
		if(minute.length === 1) {
			minute = '0'+minute;
		}
		return day+'-'+month+'-'+year+' '+hour+':'+minute;
	}
})

.filter('encodeURIComponent', function() {
    return window.encodeURIComponent;
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/app.filters.js